import {token} from "@atlaskit/tokens";
import type {CSSProperties} from "react";

/** 32×32 icon tile — bottom bar only (no border). */
export const bottomNavScaffoldIconBoxStyle: CSSProperties = {
    display: "flex",
    width: 32,
    height: 32,
    padding: token("space.050"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4,
    backgroundColor: token("color.background.neutral.subtle"),
    boxSizing: "border-box",
};

/** 48×48 icon tile — mobile create sheet (border + surface). */
export const bottomNavIconBoxStyle: CSSProperties = {
    display: "flex",
    width: 48,
    height: 48,
    padding: token("space.100"),
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 8,
    border: `1px solid ${token("color.border")}`,
    backgroundColor: token("elevation.surface"),
    boxSizing: "border-box",
};

/** Single bottom-nav slot: icon stack + label, fixed width. */
export const bottomNavItemColumnStyle: CSSProperties = {
    display: "flex",
    width: 64,
    minWidth: 0,
    maxWidth: 64,
    flexDirection: "column",
    alignItems: "center",
    gap: "5px",
    flexShrink: 0,
};

/** One-line label: ellipsis when copy longer than the slot (e.g. “Customer Lifecycle”). */
export const bottomNavItemLabelClassName =
    "min-w-0 w-full max-w-full overflow-hidden text-ellipsis whitespace-nowrap text-center";
